// components/HeroSection.jsx
import React from "react";
import "../styles/HeroSection.css";

const HeroSection = () => {
    return (
        <div className="hero-section">
            <div className="hero-overlay">
                Building Champions One Lap at a Time!!!
            </div>
        </div>
    );
};

export default HeroSection;